import React, { Fragment } from "react";
import { ConfigProvider } from "antd";
import AdminSpace from "routes/spaces/AdminSpace";
import ClientSpace from "routes/spaces/ClientSpace";
import DriverSpace from "routes/spaces/DriverSpace";
import AppError from "./AppError";
import AppLoading from "./AppLoading";
function App() {
  return (
    <ConfigProvider>
      <Fragment>
        <AppError />
        <AppLoading />
        <ClientSpace />
        <AdminSpace />
        <DriverSpace />
      </Fragment>
    </ConfigProvider>
  );
}

export default App;
